import { Observable } from 'rxjs';
import { EditGenericIncident, EditNamedIncident, IncidentsApi, PagedGenericIncidentsResponse, PagedIncidentSettingsResponse, PagedNamedIncidentsResponse, SingleGenericIncidentResponse, SingleIncidentSettingsResponse, SingleNamedIncidentResponse, UpdateGenericIncidentsOrderRequest } from 'src/app/hickory-api';
import { genericIncidentData } from './data/GenericIncidentData';
import { namedIncidentData } from './data/NamedIncidentData';
import { getPage } from './data/PageHelper';
import { mockHandler } from '../mock.handler';

export class MockIncidentsApi extends IncidentsApi {

  private emptyIncidents: PagedIncidentSettingsResponse = {
    totalItemCount: 0,
    pageCount: 1,
    page: 1,
    pageSize: 25,
    items: [],
    hasErrors: false,
    isValid: true
  };

  private _createGenericIncident(incident: EditGenericIncident): SingleGenericIncidentResponse {
    genericIncidentData.add(incident);
    return { 'item': incident };
  }
  createGenericIncident(incident: EditGenericIncident): Observable<any> {
    const response = this._createGenericIncident(incident);
    return mockHandler(response);
  }

  private _createNamedIncident(incident: EditNamedIncident): SingleNamedIncidentResponse {
    namedIncidentData.add(incident);
    return { 'item': incident };
  }
  createNamedIncident(incident: EditNamedIncident): Observable<any> {
    const response = this._createNamedIncident(incident);
    return mockHandler(response);
  }

  private _deleteGenericIncident(id: string): {} {
    genericIncidentData.delete(id);
    return {};
  }
  deleteGenericIncident(id: string): Observable<any> {
    const response = this._deleteGenericIncident(id);
    return mockHandler(response);
  }

  private _deleteNamedIncident(id: string): {} {
    namedIncidentData.delete(id);
    return {};
  }
  deleteNamedIncident(id: string): Observable<any> {
    const response = this._deleteNamedIncident(id);
    return mockHandler(response);
  }

  private _getGenericIncidentById(id: string): SingleGenericIncidentResponse {
    const incident = genericIncidentData.all.find(i => i.id === id);
    const response: SingleGenericIncidentResponse = { item: incident };
    return response;
  }
  getGenericIncidentById(id: string): Observable<any> {
    const response = this._getGenericIncidentById(id);
    return mockHandler(response);
  }

  private _getGenericIncidents(page?: number, pageSize?: number): PagedGenericIncidentsResponse {
    const response: PagedGenericIncidentsResponse = getPage(genericIncidentData.all, page, pageSize);
    return response;
  }
  getGenericIncidents(page?: number, pageSize?: number): Observable<any> {
    const response = this._getGenericIncidents(page, pageSize);
    return mockHandler(response);
  }

  private _getIncidentById(id: string): SingleIncidentSettingsResponse {
    if (genericIncidentData.all.some(i => i.id === id)) {
      return {
        item: genericIncidentData.all.find(i => i.id === id)
      };
    } else if (namedIncidentData.all.some(i => i.id === id)) {
      return {
        item: namedIncidentData.all.find(i => i.id === id)
      };
    } else {
      return {
        item: null
      }
    }
  }
  getIncidentById(id: string): Observable<any> {
    const response = this._getIncidentById(id);
    return mockHandler(response);
  }

  private _getIncidents(page?: number, pageSize?: number, type?: string, priority?: string): PagedIncidentSettingsResponse {
    let incidents: PagedIncidentSettingsResponse = this.emptyIncidents;
    if (type === 'Generic') {
      incidents = getPage(genericIncidentData.all, page, pageSize);
    } else if (type === 'Named') {
      incidents = getPage(namedIncidentData.all, page, pageSize);
    }
    return incidents;
  }
  getIncidents(page?: number, pageSize?: number, type?: string, priority?: string): Observable<any> {
    const response = this._getIncidents(page, pageSize, type, priority);
    return mockHandler(response);
  }

  private _getNamedIncidentById(id: string): SingleNamedIncidentResponse {
    return {
      item: namedIncidentData.all.find(i => i.id === id)
    };
  }
  getNamedIncidentById(id: string): Observable<any> {
    const response = this._getNamedIncidentById(id);
    return mockHandler(response);
  }

  private _getNamedIncidents(page?: number, pageSize?: number): PagedNamedIncidentsResponse {
    return getPage(namedIncidentData.all, page, pageSize);
  }
  getNamedIncidents(page?: number, pageSize?: number): Observable<any> {
    const response = this._getNamedIncidents(page, pageSize);
    return mockHandler(response);
  }

  private _updateGenericIncident(id: string, incident: EditGenericIncident): SingleGenericIncidentResponse {
    return { item: incident };
  }
  updateGenericIncident(id: string, incident: EditGenericIncident): Observable<any> {
    const response = this._updateGenericIncident(id, incident);
    return mockHandler(response);
  }

  private _updateGenericIncidentOrder(order: UpdateGenericIncidentsOrderRequest): PagedGenericIncidentsResponse {
    return getPage(genericIncidentData.all);
  }
  updateGenericIncidentOrder(order: UpdateGenericIncidentsOrderRequest): Observable<any> {
    const response = this._updateGenericIncidentOrder(order);
    return mockHandler(response);
  }

  private _updateNamedIncident(id: string, incident: EditNamedIncident): SingleNamedIncidentResponse {
    return { item: incident };
  }
  updateNamedIncident(id: string, incident: EditNamedIncident): Observable<any> {
    const response = this._updateNamedIncident(id, incident);
    return mockHandler(response);
  }
}
